/*
 * Public API Surface of angular-mentions
 */

export * from './lib/mention-config';
export * from './lib/mention.directive';
export * from './lib/mention.module';
